var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 7.60573C0.25 6.04021 1.09442 4.59641 2.4589 3.8289L7.87558 0.782075C9.19465 0.0400895 10.8054 0.0400895 12.1244 0.782075L17.5411 3.82892C18.9057 4.59643 19.75 6.04023 19.75 7.60576V13.5542C19.75 15.1198 18.9057 16.5636 17.5411 17.3311L12.1244 20.3779C10.8054 21.1198 9.19465 21.1198 7.87558 20.378L2.459 17.3314C1.09446 16.5639 0.25 15.12 0.25 13.5545V7.60573ZM6.20837 10.5802C6.20837 8.48611 7.90592 6.78853 10 6.78853C12.0941 6.78853 13.7917 8.48611 13.7917 10.5802C13.7917 12.6743 12.0941 14.3719 10 14.3719C7.90592 14.3719 6.20837 12.6743 6.20837 10.5802Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIconSelected);
export default __webpack_public_path__ + "static/media/settings-icon-selected.d569c2ee3d023708b721218dcb765b01.svg";
export { ForwardRef as ReactComponent };